module.exports = __webpack_public_path__ + "media/images/activeIconTemplate-f9ab9a89.png";